var jsonDataElement = document.getElementById('filejson_value');
var all_links = JSON.parse(jsonDataElement.textContent);
var variantSKU = document.getElementById("specification-card").dataset.variantSku;
var linkHtml = "";

document.addEventListener('DOMContentLoaded', handleSpecificationCardRender);
document.addEventListener('on:product:change', handleSpecificationCardRender);

function handleSpecificationCardRender() {
    jsonDataElement = document.getElementById('filejson_value');
    all_links = JSON.parse(jsonDataElement.textContent);
    variantSKU = document.getElementById("specification-card").dataset.variantSku;
    linkHtml = "";
    changeProductUI();
    const variantPicker = document.querySelector('variant-picker');
    if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', function (event) {
            const updatedVariant = event.detail.variant;
            //const updatedProduct = event.detail.product;
            if (updatedVariant == null) return;
            variantSKU = updatedVariant.sku;
            changeProductUI();
        });
    }
}

function changeProductUI() {
    // the spec sheet is the group named for it, never simply the first: a legacy manifest may hold only the SDoC form
    const visibleLinks = (all_links || []).filter(l => !l.label.includes("Declaration"));
    if (visibleLinks.some(l => l.content && l.content.length)) {
        const link = visibleLinks.find(l => /spec|datasheet/i.test(l.label) && l.content && l.content.length);
        const totalFiles = visibleLinks.reduce((n, l) => n + (l.content ? l.content.length : 0), 0);
        const otherCats = visibleLinks.filter(l => l !== link).map(l => l.label.toLowerCase().trim()).join(" & ");
        const allDocsLabel = `All documents (${totalFiles})${otherCats ? " — " + otherCats : ""} →`;
        linkHtml = `
              <div class="pdp-docs">
${link ? `<a class="pdp-doc" href="${link.content[0].url}" download="SpecSheet(${variantSKU})" target="_blank" rel="noopener">
                  <span class="dl-icon-sm">PDF</span>
                  <span class="pdp-doc-label">
                    <b>Spec sheet — ${variantSKU}</b>
                    <small>Full datasheet, derating curves &amp; dimensions</small>
                  </span>
                  <svg class="dl-arrow" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12m0 0 4-4m-4 4-4-4M4 21h16"/></svg>
                </a>` : ""}
                <button class="pdp-doc-more" type="button" onclick="scrollToDownloads()">${allDocsLabel}</button>
              </div>
            `;
        document.getElementById("specification-card").innerHTML = linkHtml;
        let linksHtml = all_links?.filter(link => !link.label.includes("Declaration")).map(link => {
        return `
        <div class="psm-dl-group">
          <h4 class="psm-dl-group-title">${link.label}<span class="psm-dl-group-count">${(link.content || []).length}</span></h4>
          ${getContent(link.content)}
        </div>
      `;
    });
        setTimeout(() => renderLinksUnderFileDownload(linksHtml), 500)
    } else {
        setTimeout(() => {
            let aaa = document.querySelectorAll('div.disclosure__content p, [role="tabpanel"] p');
            aaa.forEach(a => {
                if (a.textContent === "::specification::") {
                    a.closest('details-disclosure').style.display = 'none';
                }
            });
        }, 100)
    }
}

function scrollToDownloads() {
    let specificationElement = document.getElementById("spec_sheet_links");
    if (!specificationElement) return;
    const panel = specificationElement.closest('[role="tabpanel"]');
    if (panel) {
        // tabs mode: activate the File Downloads tab
        const tabBtn = document.getElementById(panel.getAttribute('aria-labelledby'));
        if (tabBtn) tabBtn.click();
    } else {
        const det = specificationElement.closest('details');
        if (det) det.setAttribute("open", "");
    }
    scrollToTargetAdjusted(specificationElement);
}

function renderLinksUnderFileDownload(linksHtml) {
    let aaa = document.querySelectorAll('div.disclosure__content p, [role="tabpanel"] p');
    aaa.forEach(a => {
        if (a.textContent === "::specification::") {
            a.parentElement.innerHTML = `<div id="spec_sheet_links">${
                linksHtml.join("")
            }</div>`
        }
    });
}

// helper functions
function getContent(content) {
    let contentHtml = content?.map(link => {
        const ext = (link.url || "").split(".").pop().split("?")[0].toUpperCase().slice(0, 4) || "PDF";
        return `
        <a class="psm-dl-row" href="${link.url}" download="${link.name}" target="_blank" rel="noopener">
          <span class="dl-icon-sm">${ext}</span>
          <span class="psm-dl-name">${link.name}</span>
          <svg class="dl-arrow" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12m0 0 4-4m-4 4-4-4M4 21h16"/></svg>
        </a>
      `;
    }).join("");
    return `<div class="psm-dl-list">${contentHtml}</div>`;
}

function scrollToTargetAdjusted(element) {
    var headerOffset = 150;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({top: offsetPosition, behavior: "smooth"});
}
